module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#women-home",
      toString: function () {
        return this.url;
      }
    }